import pages from '../namespaces/pages/zh-TW';
import components from '../namespaces/components/zh-TW';
import common from '../namespaces/common/zh-TW';
import errors from '../namespaces/errors/zh-TW';
import validation from '../namespaces/validation/zh-TW';
import gameDetail from '../namespaces/gameDetail/zh-TW';

export default {
  common,
  pages,
  components,
  errors,
  validation,
  gameDetail
}; 